import React from "react";
import { Button } from "@mui/material";
import InstallingIcon from '@mui/icons-material/InstallDesktop';


const InstallButton = ({
    label,
    color = "white",
    iconColor = "#105b2b",
    variant = "contained",
    startIcon,
    onClick,
    sx = {},
    ...props
}) => {

    return (
        <Button
            color={color}
            variant={variant}
            onClick={onClick}
            startIcon={startIcon || <InstallingIcon color={iconColor} />}
            {...props}
            sx={{ pt: 1, pb: 1, pl: 4, pr: 4, borderRadius: 8, ...sx }}
        >
            {label}
        </Button>
    );
};

export default InstallButton;